import React, { Dispatch, SetStateAction } from "react";
import { GameState, TLevel } from "../pages/Game/GamePlayer/GamePlayer";
import dayjs from "dayjs";

export const GameStateContext = React.createContext<{
    state: GameState,
    setState: Dispatch<SetStateAction<GameState>>,
    points: number,
    addPoints: (value: number) => void,
    level: TLevel,
    playerId: number,
    resetGame: (action: 'init' | 'play-again') => void,
}>({
    state: 'intro',
    setState: () => {},
    points: 0,
    addPoints: () => {},
    level: 1,
    playerId: dayjs().unix(),
    resetGame: (action: 'init' | 'play-again') => {},
})
